module.exports = __webpack_public_path__ + "static/media/33.f852bdf7.png";